import React from "react";

export default function Footer() {
  return (
    <div className="container mt-5 pt-4 mx-auto">
      <p>Made with ❤️ in India.</p>
    </div>
  );
}
